var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.activeName == 'product')?_c('Product'):_vm._e(),_vm._v(" "),(_vm.activeName == 'settings')?_c('Settings'):_vm._e(),_vm._v(" "),(_vm.activeName == 'record')?_c('Record'):_vm._e(),_vm._v(" "),(_vm.activeName == 'page')?_c('Page'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a976b38","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/plus/points/index.vue
// module id = null
// module chunks = 